import { ExperienceTemplateRenderer, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { IntersectionTracker } from '@shared-ui/clickstream-analytics-context';

import { z } from 'zod';

export const IntersectionTrackerWrapper: React.FC<TemplateComponentProps> = ({ templateComponent }) => {
  const { children, config } = templateComponent;

  const configSchema = z.optional(
    z.object({
      rfrrId: z.string(),
      linkName: z.string(),
    })
  );
  const result = configSchema.safeParse(config);

  if (!result.success) {
    return null;
  }
  const { rfrrId = '', linkName = '' } = result.data ?? {};

  return (
    <IntersectionTracker trackOnce={true} referrerId={rfrrId} linkName={linkName}>
      {children && <ExperienceTemplateRenderer templateComponents={children} />}
    </IntersectionTracker>
  );
};
